export default "__VITE_ASSET__Xux8boUz__"